import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'upperCategories',
  pure: false
})
export class CategoriesUppercase implements PipeTransform {
  transform(item: string, filter: string): any {
    let lowercaseCategories = ['api', 'ecm', 'rpa'];
    if (lowercaseCategories.includes(item.toLowerCase())) {
      return item.toUpperCase();
    } else {
      return item;
    }
  }
}
